<div id="studentStoryModalComponent">
  <form autocomplete="off" id="studentAvatarStoryForm" class="d-flex flex-column justify-content-center align-items-end" [formGroup]="avatarForm" name="avatarForm">
    <div class="modal-body w-100">
      <ngb-carousel #carousel>
        @for (slide of slides; track $index; let i = $index) {
          <ng-template ngbSlide>
            <div [class.form-group]="slide.requiresInput" [class.mt-5]="slide.requiresInput">
              @if (slide.imageName) {
                <img class ="p-1 w-75 d-block mx-auto" src="assets/img/blobStory/{{ slide.imageName }}" role="presentation" alt="">
              }
              <div id="{{ slide.requiresInput ? slide.formControlName + 'Label' : 'slide' + i}}" class="markdown text-center mx-auto w-75" [innerHTML]="renderSlideCaption(slide.captionText)"></div>
              @if (slide.requiresInput) {
                @if (slide.formControlName === 'name') {
                  <input
                    class="form-control w-50 m-auto shadow-none"
                    name="name"
                    type="text"
                    required
                    maxlength="30"
                    aria-labelledby="nameLabel"
                    formControlName="name">
                }
                @if (slide.formControlName === 'color') {
                  <div class="w-50 mx-auto">
                    <zbp-color-picker name="color" id="storyColor" aria-labelledby="colorLabel" [useNative]="false" formControlName="color"></zbp-color-picker>
                  </div>
                }
              }
            </div>
          </ng-template>
        }
      </ngb-carousel>
    </div>
    <div class="modal-footer border-top-0 justify-content-center">
      <div class="d-flex w-100">
        <button id="nextButton" #nextButton class="btn text-lowercase ms-auto" [disabled]="nextButtonDisabled()" (click)="next()">Next</button>
      </div>
    </div>
  </form>
</div>
